import { CheckedChangeDetails } from '@chakra-ui/react/dist/types/components/checkbox/namespace';
import { useFormContext } from 'react-hook-form';

import { Checkbox } from 'shared';

import { CoachingToolNote, SessionType } from 'features/sessions/config/types';

type SessionFormCoachingToolCompletedProps = {
  coachingTool: CoachingToolNote;
  formKey: string;
};

export const SessionFormCoachingToolCompleted = ({
  coachingTool,
  formKey,
}: SessionFormCoachingToolCompletedProps) => {
  const { setValue } = useFormContext<SessionType>();

  return (
    <Checkbox
      checked={coachingTool.isCompleted}
      onCheckedChange={(e: CheckedChangeDetails) => {
        // @ts-ignore
        const isCompleted = !!e.checked;

        setValue(`${formKey}.isCompleted` as keyof SessionType, isCompleted, {
          shouldDirty: false,
        });
      }}
    >
      Completed
    </Checkbox>
  );
};
